module.exports = __webpack_public_path__ + "img/page2.4e1ce85b.jpeg";